<template>
  <div class="view-wrap">
    <section class="bg-regular view-inner">
      <div class="section-inner">
        <div class="container">
          <div class="row">
            <div class="col-12 col-sm-4 col-md-3 support-bear">
              <img src="./images/supportbear.png" alt="">
            </div>
            <div class="col-12 col-sm-8 col-md-9">
              <p v-if="alert" class="alert alert-warning">
                Our scheduled RememBear maintenance has been completed and we're continuing to monitor things on our end. If you're having trouble syncing, try locking and unlocking RememBear. If issues persist, let us know by filling out this form to submit a ticket.
              </p>
              <h1 class="h3">Contact a Support Bear</h1>
              <!-- <form v-if="!thanks" class="questions form-area" v-on:submit.prevent="submit()">
                <div class="question-block">
                  <h4>How can we help?</h4>
                  <div class="radios">
                    <label v-for="(question, key) in questions.main">
                      <input v-model="main" type="radio" name="main" :value="key">{{ question }}
                    </label>
                  </div>
                </div>
                <div v-if="main && main !== 'question'">
                  <div class="question-block">
                    <h4>What do you want to roar about?</h4>
                    <div class="input-wrap">
                      <div class="radios" :class="{ 'show-error' : currentError === 'problem' }">
                        <p class="field-error">Grrr... please select an issue.</p>
                        <label v-for="(problem, key) in questions[main]">
                          <input v-model="issue.problem" type="radio" name="problem" :value="key">{{ problem }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div v-if="main && main === 'functionality'" class="question-block">
                    <h4>Which platform are you using?</h4>
                    <div class="input-wrap">
                      <div class="checkboxes" :class="{ 'show-error' : currentError === 'platform' }">
                        <p class="field-error">Rawr... can you let us know what platform you're using?</p>
                        <label v-for="(platform, key) in questions.platform">
                          <input v-model="issue.platform" type="checkbox" name="platform" :value="key">{{ platform }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="phase === 2">
                  <div class="question-block">
                    <h4>Give us a quick description (just a few sentences)</h4>
                    <div class="input-wrap" :class="{ 'show-error' : currentError === 'description' }">
                      <p class="field-error">Grr... Don't forget to give us a description of your problem.</p>
                      <textarea v-model="issue.description" name="description" maxlength="500"></textarea>
                      <p class="count fine-print" v-html="issue.description.length + '/500'"></p>
                    </div>
                  </div>
                  <div class="question-block">
                    <h4>Account email address (we’ll send a reply to this email)</h4>
                    <div class="input-wrap" :class="{ 'show-error' : currentError === 'email' }">
                      <p class="field-error">Grr... Please enter a valid email address</p>
                      <input v-if="loggedInEmail" type="email" :value="loggedInEmail" name="email" disabled="disabled">
                      <input v-else type="email" v-model="issue.email" name="email">
                    </div>
                  </div>
                  <p class="field-error" :class="{ 'show-error' : submitError }">{{ submitError }}</p>
                  <button :disabled="submitting" class="btn btn-lg">Send Message</button>
                </div>
              </form> -->
              <div>
                <p>Our Bears are having some trouble receiving support ticket submissions right now. If you'd like to get in touch, please email us directly at <a href="mailto:support@remembear.com">support@remembear.com</a> and we'll do our best to get back to you within 72 hours.</p>
              </div>
              <div v-if="thanks">
                <p><strong>Rawr! We’ve received your message.</strong></p>
                <p>A support bear will be in touch shortly. We do our best to respond to all tickets within 48 hours. Please be aware that following up multiple times before we have the chance to reply can delay us in getting to your initial message.</p>
                <p>While you wait, check out our <a :href="external.help">help section</a>.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import is from 'is_js'
import services from '../../services/services.js'
import Cookies from 'js-cookie'

export default {
  name: 'support',
  data () {
    return {
      thanks: false,
      is: is,
      alert: new Date() < new Date(2021, 3, 9, 9, 0),
      questions: {
        main: {
          functionality: 'RememBear doesn\'t work properly',
          subscription: 'I\'m having an issue with my subscription or payment',
          account: 'I\'m having an issue with my RememBear account',
          feedback: 'I have general feedback or a feature request',
          question: 'I have a general question about RememBear'
        },
        functionality: {
          installation: 'I\'m having trouble installing RememBear',
          using: 'I\'m having trouble using RememBear',
          crashing: 'The RememBear app is crashing'
        },
        subscription: {
          upgrade: 'I want to upgrade my account',
          cancel: 'I want to cancel my account',
          billing: 'There\'s been a billing error'
        },
        account: {
          creation: 'I\'m having trouble creating my account',
          access: 'I\'m having trouble accessing my account',
          delete: 'I want to delete my account'
        },
        feedback: {
          request: 'I have a feature request',
          feedback: 'I have some feedback for the Bears'
        },
        platform: {
          windows: 'Windows',
          mac: 'macOS',
          android: 'Android',
          ios: 'iOS',
          browser: 'Browser extension'
        }
      },
      main: '',
      issue: {
        problem: '',
        platform: [],
        description: '',
        email: ''
      },
      submitted: false,
      submitting: false,
      submitError: '',
      showWarning: false,
      loggedInEmail: ''
    }
  },
  beforeMount: function () {
    if (this.$store.getters.isLoggedIn) {
      this.$store.dispatch('prepareUserData').then(response => {
        this.loggedInEmail = this.$store.getters.userData.email
      })
    }
  },
  computed: {
    phase: function () {
      let phase = (this.issue.problem || this.main === 'question') ? 2 : 1
      return phase
    },
    errors: function () {
      let errors = []
      if (!this.issue.platform && this.main === 'functionality') {
        errors.push('platform')
      }
      if (!this.issue.problem && this.main !== 'question') {
        errors.push('problem')
      }
      if (!this.issue.description || this.issue.description.length < 10) {
        errors.push('description')
      }
      let email = this.loggedInEmail || this.issue.email
      if (!email || is.not.email(email)) {
        errors.push('email')
      }
      return errors
    },
    currentError: function () {
      if (!this.submitted) return ''
      let currentError = ''
      if (this.errors.length > 0) {
        currentError = this.errors[0]
      }
      return currentError
    }
  },
  methods: {
    gatherInfo: function () {
      var info = []
      info.push('How can we help?: ' + this.questions.main[this.main])
      if (this.main !== 'question') {
        info.push('Whats the problem?: ' + this.questions[this.main][this.issue.problem])
      }
      if (this.issue.platform.length > 0) {
        for (let platform of this.issue.platform) {
          info.push('Which platforms are affected?: ' + platform)
        }
      }
      info.sort()
      return JSON.stringify(info)
    },
    makeRequest: function () {
      if (this.submitting) return
      this.submitting = true
      var data = {
        title: this.issue.description.substr(0, 49),
        message: this.issue.description,
        additionalInfo: this.gatherInfo(),
        fromAddress: this.loggedInEmail || this.issue.email
      }

      this.$http.post(this.ENV.apiBaseUrl + '/support/feedback', data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        let time = new Date()
        time.setTime(time.getTime() + 1 * 3600 * 1000)
        Cookies.set('supportSpam', true, {expires: time})
        this.thanks = true
        document.body.scrollTop = document.documentElement.scrollTop = 0
        this.submitting = false
      }).catch(error => {
        if (error) {
          this.submitError = 'Whoops... something went wrong with your request. Please refresh and try again.'
          this.submitting = false
        }
      })
    },
    resetForm: function () {
      this.submitted = false
      this.issue = {
        problem: '',
        platform: [],
        description: '',
        email: ''
      }
    },
    resetOptions: function () {
      this.issue.problem = ''
      this.issue.platform = []
    },
    submit: function () {
      this.submitError = ''
      this.submitted = true
      if (this.errors.length === 0) {
        if (Cookies.get('supportSpam')) {
          this.submitError = 'Oops, you\'ve already sent a request in the last hour.'
        } else {
          this.makeRequest()
        }
      }
    }
  },
  watch: {
    main: function () {
      this.resetForm()
      this.submitError = ''
    }
  }
}
</script>

<style scoped lang="stylus" src="./support.styl" >



// WEBPACK FOOTER //
// src/views/support/support.vue